<template>
  <div id="adjunto-data">
    <input
      v-if="tipeView != 'consulta' && centrotab != 'centro'"
      type="file"
      id="visita-file"
      name="visitaFile"
      :accept="tipeArchive"
      color="primary"
      dark
      class="mb-2"
      @change="processFile4"
      multiple
    />
    <v-text-field
      v-if="tipeView == 'oculto' && centrotab != 'centro'"
      v-model="filenameValue4"
      label="Filename"
      :box="(isDisabled = true)"
      :readonly="(isDisabled = true)"
      @input="$v.filename.$touch()"
      @blur="tipeView == 'crear' ? $v.filename.$touch() : null"
    ></v-text-field>
    <v-text-field
      v-if="tipeView == 'oculto' && centrotab != 'centro'"
      v-model="idCalidadValue"
      label="id Calidad"
      :box="(isDisabled = true)"
      :readonly="(isDisabled = true)"
    ></v-text-field>
    <v-text-field
      v-if="tipeView == 'oculto' && centrotab != 'centro'"
      v-model="base64Value4"
      label="Encrypt"
      :box="(isDisabled = true)"
      :readonly="(isDisabled = true)"
      @input="$v.base64Value.$touch()"
      @blur="tipeView == 'crear' ? $v.base64Value.$touch() : null"
    ></v-text-field>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "AdjuntoData",
  components: {},
  props: {
    centrotab: "",
    tipeView: "",
    tipeArchive: "",
  },
  data() {
    return {
      contratoId: "",
      base64Value: "",
      filenameValue: "",
      base64Value2: "",
      filenameValue2: "",
      base64Value3: "",
      filenameValue3: "",
      base64Value4: "",
      filenameValue4: "",
      filex: "",
    };
  },

  computed: {},

  created() {},
  methods: {
    readFileAsync(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onloadend = (file) => {
          resolve(reader.result.split(",")[1]);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },

    async processFile4(e) {
      try {
        let file = e.target.files[0];
        // this.filex = file

        this.filenameValue4 = file.name;
        this.base64Value4 = await this.readFileAsync(file);
        this.$parent.base64Value4 = this.base64Value4;
        this.$parent.filenameValue4 = this.filenameValue4;
        // this.$parent.file = this.filex
      } catch (err) {
        console.log(err);
      }
      // this.$parent.$parent.filex = this.filex;
      this.$parent.$parent.base64Value4 = this.base64Value4;
      this.$parent.$parent.filenameValue4 = this.filenameValue4;
      // this.$parent.$parent.$parent.filex = this.filex;
      this.$parent.$parent.$parent.base64Value4 = this.base64Value4;
      this.$parent.$parent.$parent.filenameValue4 = this.filenameValue4;
      // this.$parent.$parent.$parent.$parent.filex = this.filex;
      this.$parent.$parent.$parent.$parent.base64Value4 = this.base64Value4;
      this.$parent.$parent.$parent.$parent.filenameValue4 = this.filenameValue4;
    },
    //Guardado en el store
    //this.base64Value = this.$store.getters.base64Stored;
    //this.filenameValue = this.$store.getters.filenameStored;
  },
};
</script>
